import { render } from "./SgeView.vue?vue&type=template&id=f7baf260&scoped=true"
import script from "./SgeView.vue?vue&type=script&lang=js"
export * from "./SgeView.vue?vue&type=script&lang=js"

import "./SgeView.vue?vue&type=style&index=0&id=f7baf260&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7baf260"]])

export default __exports__